import React from "react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import useModalDialog from "../../../hooks/useModalDialog.js";
import { FlightCampaignTCBannerModalContent } from "./FlightCampaignTCBannerModalContent.js";
import styles from "./FlightCampaignTCBannerModal.module.css";
export const FlightCampaignTCBannerModal = ({ isActive, campaignBanner, onModalClose }) => {
    const i18n = useI18n();
    const Modal = useModalDialog();
    return (React.createElement(Modal, { active: isActive, fill: true, onClose: onModalClose, closeAriaLabel: campaignBanner.action.closeButtonAccessibility || i18n.trans(t("a11y_flights_deal_banner_detail_close")), title: React.createElement("div", { className: styles.modalHeader },
            React.createElement("h2", { id: "deal-modal-title", className: styles.modalHeaderTitle }, campaignBanner.action.title),
            campaignBanner.action.subtitle && (React.createElement("div", { className: styles.modalHeaderSubtitle }, campaignBanner.action.subtitle))), attributes: { "aria-labelledby": "deal-modal-title" } },
        React.createElement(FlightCampaignTCBannerModalContent, { campaignBanner: campaignBanner })));
};
